import { useQuery } from '@tanstack/vue-query'
import { toValue, type MaybeRefOrGetter } from 'vue'
import { propertyKeys } from '../propertyQueryKeys'
import { getPropertyDocuments } from '../propertyEndpoints'

export function usePropertyDocumentsQuery(id: MaybeRefOrGetter<string>) {
  return useQuery({
    queryKey: () => propertyKeys.documents(toValue(id)),
    queryFn: () => getPropertyDocuments(toValue(id)),
    enabled: () => Boolean(toValue(id)),
  })
}
